import { render, staticRenderFns } from "./ChamadaPesquisa.vue?vue&type=template&id=242a6e3f&scoped=true&"
import script from "./ChamadaPesquisa.vue?vue&type=script&lang=js&"
export * from "./ChamadaPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./ChamadaPesquisa.vue?vue&type=style&index=0&id=242a6e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a6e3f",
  null
  
)

export default component.exports